import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import user_service from "../service/user_service";
import Loader from "../../Pages/Loader/Loader.js";
import jwt from "jwt-decode";
import Pic from "../img/pic.png";
import VendorImage from "../img/venders.png?egrewrygewr";

const Vender = () => {
  const [loader, setLoader] = useState({ isActive: null });
  const { isActive } = loader;
  const [products, setProducts] = useState([]);
  const [vendorCategoryFilter, setVendorCategoryFilter] = useState("all");

  const PromotoProductsGet = async () => {
    const office = localStorage.getItem("active_office") || "";
    setLoader({ isActive: true });
    try {
      const promotoResp = await user_service.PromotoProductsGet(office);
      const allPromoto = promotoResp?.data?.data || [];
      const groupedBycategory = allPromoto.reduce((acc, item) => {
        const category = item.category;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {});

      const vendorCatalogItems = allPromoto.filter(
        (item) => String(item.category || "").toLowerCase() === "vendor"
      );
      const vendorCatalogTiles = vendorCatalogItems.map((item) => ({
        _id: `catalog-${item._id}`,
        promotoId: item._id,
        title: item.title,
        image: item.image || Pic,
        category: item.description || item.title,
        source: "catalog",
        detailPath: `/sub-vendor/${item._id}`,
      }));

      groupedBycategory.vendor = [...vendorCatalogTiles];
      setProducts(groupedBycategory);
    } catch (e) {
      console.error(e);
    }
    setLoader({ isActive: false });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    PromotoProductsGet();
  }, []);

  const vendorList = products.vendor || [];
  const vendorCategories = useMemo(
    () => [...new Set(vendorList.map((x) => x.category).filter(Boolean))],
    [vendorList]
  );
  const vendorFiltered =
    vendorCategoryFilter === "all"
      ? vendorList
      : vendorList.filter((x) => x.category === vendorCategoryFilter);

  function populateSection(sectionId, items) {
    if (!items || items.length === 0) {
      return (
        <div className="NoItemProducts float-left w-100 text-center mt-4">
          <img src={VendorImage} alt="" />
          <p className="text-white">There's no data to show</p>
        </div>
      );
    }

    return (
      <div className="FeaturedBox" key={sectionId}>
        <div className="row">{items.map((item) => generateItemHTML(item))}</div>
      </div>
    );
  }

  function generateItemHTML(item) {
    const to = item.detailPath || `/sub-vendor/${item._id}`;
    return (
      <div
        className="col-lg-3 col-md-6 col-sm-6 col-12 tns-item tns-slide-cloned tns-slide-active p-3"
        key={item._id}
      >
        <div className="card shadow-sm cursor-pointer card-hover border-0 h-100">
          <div className="card-img-top card-img-hover">
            <NavLink to={to}>
              <img
                className="img-fluid rounded-0 w-100"
                src={item.image}
                alt="images"
              />
            </NavLink>
          </div>
          <div className="card-body position-relative text-center pb-3">
            <NavLink to={to}>{item.title}</NavLink>
          </div>
          <div className="read-more float-left w-100 text-center mb-3">
            <NavLink to={to} className="">
              View Details
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-secondary float-left w-100 pt-4 mb-4">
      <Loader isActive={isActive} />
      <div className="">
        <main className="page-wrapper homepage_layout commonpage_layout">
          <div className="">
            <div className="">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h3 className="pull-left mb-0 text-white">Catalog</h3>
                {localStorage.getItem("auth") &&
                jwt(localStorage.getItem("auth")).contactType == "admin" ? (
                  <NavLink
                    className="btn btn-info mb-2 pull-right"
                    to="/add-promotecatalog"
                  >
                    Add New Catalog
                  </NavLink>
                ) : (
                  ""
                )}
              </div>
              <div>
                <hr className="mb-3 w-100" />
                <div
                  className="float-left w-100 mt-4"
                  style={{ paddingleft: "2rem" }}
                >
                  <div id="GalleryGrid">
                    <h6 className="text-white">Vendors</h6>
                    {vendorCategories.length > 0 ? (
                      <div className="mb-3">
                        <label className="text-white mb-1 d-block small">
                          Filter by category
                        </label>
                        <select
                          className="form-select form-select-sm"
                          style={{ maxWidth: 280 }}
                          value={vendorCategoryFilter}
                          onChange={(e) =>
                            setVendorCategoryFilter(e.target.value)
                          }
                        >
                          <option value="all">All</option>
                          {vendorCategories.map((c) => (
                            <option key={c} value={c}>
                              {c}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                    {populateSection("VendorsSection", vendorFiltered)}
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Vender;
